import { roundDecimalPlaces, distancePt } from './utils.js'


class ShapeRadialGroups {

    constructor(
        shape,
    ) {
        this.shape = shape
    }


    distancePt(centerPt, param, distance) {
        let cx = centerPt.x
        let cy = centerPt.y
        let startPt = {'x': cx, 'y': cy}
        let endPt = this.shape.getCoordinates(param)
        return {'x': roundDecimalPlaces(((endPt.x - startPt.x) * distance + startPt.x), 3), 'y': roundDecimalPlaces(((endPt.y - startPt.y) * distance + startPt.y), 3)}
    }

    getOuterParamsGroup(args) {
        let outerParams = []
        let start, end, arc, step, prevStart, changeRepeat, change
        let arcs = args.getGroupArcs()
        let n = 0
        for (let g of args.getGroups()) { 
            prevStart = 0
            step = 1 / g
            arc = arcs.length > 0 ? arcs.shift() : arc
            outerParams.push([])
            changeRepeat = args.getSweepChangeRepeat(n)
            for (let i = 0; i < g; i++) {
                change = changeRepeat[i % changeRepeat.length]
                start = roundDecimalPlaces(prevStart + step, 4)
                end = roundDecimalPlaces(start + arc * changeRepeat, 4)
            if (args.isCentered) {
                let neuStart = roundDecimalPlaces(start + Math.abs(step - arc) / 2, 4)
                let neuEnd = roundDecimalPlaces(neuStart + arc, 4)
                outerParams.at(-1).push(neuStart, neuEnd)
            } else {
                outerParams.at(-1).push(start, end)
            }
            prevStart = start
            }
            n++
        }
        return outerParams
    }


    getRadialPoints(args, outerParams) {
        let curvePoints = []
        let radii = []
        let rads = args.getGroupRadii()
        let centerPts = args.getCenterPts()
        let rad, distance, centerPt, changeRepeat, change
        let n = 0
        for (let groupParams of outerParams) {
            curvePoints.push([])
            radii.push([])
            rad = rads.length > 0 ? rads.shift() : rad
            centerPt = centerPts.length > 0 ? centerPts.shift() : centerPt
            for (let i = 0; i < groupParams.length - 1; i+=2) {
                changeRepeat = args.getRadiusChangeRepeat(n)
                change = changeRepeat[(i / 2) % changeRepeat.length]
                distance = rad * change
                radii.at(-1).push(distance)
                curvePoints.at(-1).push(distancePt(this.shape, centerPt, groupParams.at(i), distance))
                curvePoints.at(-1).push(distancePt(this.shape, centerPt, groupParams.at(i + 1), distance))
            }
            n++
        }
        return [radii, curvePoints]
    }


    buildRadial(args, shape, points, params, radius, centerPt) {
        let path = ``

        // Go to start
        path = `${path} M ${centerPt.x} ${centerPt.y} `

        // Go to start of outer arc
        path = `${path} L ${points[0].x} ${points[0].y} `

        // Draw outer arc or line
        path = args.connectPoints ? `${path} L ${points[1].x} ${points[1].y} ` : `${path} ${shape.getSubCurveRelative(...params, radius)} `

        // Line back to start
        path = `${path} L ${centerPt.x} ${centerPt.y} `
        return path
    }


    getRadialShapes(args, outerParams, outerPoints, radii) {
        let shapePaths = []
        let n = 0
        let centerPts = args.getCenterPts()
        for (let paramGroup of outerParams) {
            let pointGroup = outerPoints[n]
            let radiiGroup = radii[n]
            let centerPt = centerPts.length > 0 ? centerPts.shift() : centerPt
            for (let i = 0; i < pointGroup.length - 1; i+=2) {
                let points = pointGroup.slice(i, i + 2)
                let params = paramGroup.slice(i, i + 2)
                let radius = radiiGroup.at(i / 2)
                shapePaths.push(this.buildRadial(args, this.shape, points, params, radius, centerPt))
            }
            n++
        }
        return shapePaths
    }


    getRadials(
        args
    ) {

        let outerParams = this.getOuterParamsGroup(args)
        let [radii, radialPoints] = this.getRadialPoints(args, outerParams)
        let radialShapes = this.getRadialShapes(args, outerParams, radialPoints, radii)
        return radialShapes
    }
}

export { ShapeRadialGroups }
